import { defineMessages } from 'react-intl';

export const scope = 'app.containers.candidates';

export default defineMessages({
  candidate: {
    id: `${scope}.candidates`,
    defaultMessage: 'Candidate',
  },
});
